module.exports = __webpack_public_path__ + "i18n/zh-CN.e2b17eb7b50ce74aa7110ec5620486ad.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=i18n/[name].[hash].[ext]!./i18n/zh-CN.json
// module id = 857
// module chunks = 60